import SrcContent from "@/sections/Collaboration/SrcContent";
import RecordController from "./RecordController";
import { message } from "antd";
import Dialog from "@/component/Dialog";
import { useState, useEffect } from "react";
import { clearSubtitle } from "@/services/simulInter";
import { useControlWebSocket } from "@/hooks/useControlWebSocket";
import deviceStore from "@/store/device.store";
import { useCollaborationSocket } from "@/hooks/useCollaborationSocket";

const CollaborationView = ({
  streamName,
  onShowJumpSummaryDialog
}: {
  streamName: string;
  onShowJumpSummaryDialog?: (show: boolean) => void;
}) => {
  const [showModal, setShowModal] = useState(false);
  const {
    setMeetingFinish,
    showJumpSummaryDialog,
    handleJumpSummary,
  } = useCollaborationSocket(streamName);

  const {
    pauseRecording: wsPauseRecording,
    resumeRecording: wsResumeRecording,
    stopRecording: wsStopRecording,
    disconnect: wsDisconnect,
    clearSubtitle: wsClearSubtitle,
  } = useControlWebSocket();

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleClearScreen = async () => {
    console.log("一键清除大屏字幕");
    try {
      await clearSubtitle(streamName);
    } catch (error) {
      console.error("后台接口清除大屏字幕失败:", error);
      message.error("清除大屏字幕失败");
    }

    // 检查 WebSocket 连接状态
    const { wsConnected } = deviceStore.getState();
    if (!wsConnected) return;
    // 补充调用 WebSocket 清屏指令，确保大屏字幕清除
    wsClearSubtitle();
    message.warning("已清除大屏字幕");
  };

  const handleConfirmFinish = async () => {
    console.log("确认结束录制");

    // 检查 WebSocket 连接状态
    const { wsConnected } = deviceStore.getState();
    if (!wsConnected) {
      message.error("设备连接已断开，无法结束");
      setShowModal(false);
      return;
    }

    try {
      setShowModal(false);
      // 发送停止录制指令（等待响应）
      await wsStopRecording();
      wsDisconnect();
      deviceStore.getState().resetStore();
      // 2s后弹框提醒
      setTimeout(() => {
        console.log('setMeetingFinish(true)');
        setMeetingFinish(true);
      }, 2000);
    } catch (error) {
      console.error("结束录制失败:", error);
      message.error("结束录制失败，请重试");
      setShowModal(false);
    }
  };

  const handleFinish = () => {
    setShowModal(true);
  };

  // 监听 showJumpSummaryDialog 变化，通知父组件
  useEffect(() => {
    onShowJumpSummaryDialog?.(showJumpSummaryDialog);
  }, [showJumpSummaryDialog, onShowJumpSummaryDialog]);

  return (
    <div className="relative flex flex-col justify-center items-center flex-1 rounded-2 bg-#FFF ">
      <SrcContent streamName={streamName} className="px-6 pt-6" />
      <div className="absolute bottom-16 left-0 w-full h-12 bg-gradient-to-b from-#7876AA00 to-#7876AA0F" />
      <RecordController
        pauseRecording={wsPauseRecording}
        resumeRecording={wsResumeRecording}
        onClearScreen={handleClearScreen}
        onFinish={handleFinish}
      />
      <Dialog
        isOpen={showModal}
        title={"确定结束会议录制吗？"}
        content={"确定后，大屏将结束录制"}
        confirmText={"结束录制"}
        cancelText={<div className="px-2.75 flex items-center">取 消</div>}
        onConfirm={handleConfirmFinish}
        onCancel={handleCancel}
      />
      <Dialog
        isOpen={showJumpSummaryDialog}
        hasCancel={false}
        onConfirm={handleJumpSummary}
        confirmType="primary"
        confirmText="知道了"
        confirmTimeout={10 * 1000}
        title="大屏会议已结束"
        content="正在为你跳转智能总结详情"
      />
    </div>
  );
};

export default CollaborationView;
